var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _vm.statusForm == "login"
        ? _c(
            "el-form",
            {
              ref: "form",
              staticClass: "login-form",
              attrs: {
                model: _vm.loginForm,
                rules: _vm.loginRules,
                autocomplete: "on",
                "label-position": "left",
              },
            },
            [
              _c("div", { staticClass: "title-container text-center" }, [
                _c("img", {
                  staticStyle: { filter: "brightness(5)" },
                  attrs: {
                    src: require("@/assets/images/logo.png"),
                    width: "200",
                    alt: "",
                  },
                }),
              ]),
              _c("h2", { staticClass: "text-center" }, [
                _vm._v("Account recovery"),
              ]),
              _c(
                "el-form-item",
                { attrs: { prop: "username" } },
                [
                  _c(
                    "span",
                    { staticClass: "svg-container" },
                    [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                    1
                  ),
                  _c("el-input", {
                    ref: "username",
                    attrs: {
                      placeholder: "Username",
                      name: "username",
                      type: "text",
                      tabindex: "1",
                      autocomplete: "on",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSendOTP($event)
                      },
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "username", $$v)
                      },
                      expression: "loginForm.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "email" } },
                [
                  _c(
                    "span",
                    { staticClass: "svg-container" },
                    [_c("svg-icon", { attrs: { "icon-class": "email" } })],
                    1
                  ),
                  _c("el-input", {
                    ref: "email",
                    attrs: {
                      placeholder: "Enter your email",
                      name: "email",
                      type: "text",
                      tabindex: "1",
                      autocomplete: "on",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSendOTP($event)
                      },
                    },
                    model: {
                      value: _vm.loginForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "email", $$v)
                      },
                      expression: "loginForm.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%", "margin-bottom": "10px" },
                  attrs: { loading: _vm.loading, type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSendOTP($event)
                    },
                  },
                },
                [_vm._v("Send OTP")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%", "margin-bottom": "30px" },
                  attrs: { loading: _vm.loading, type: "text" },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$router.push("/")
                    },
                  },
                },
                [_vm._v("Back to home")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("reset-password", {
        ref: "resetPasswordRef",
        attrs: { token: _vm.resetToken, username: _vm.username },
        on: {
          "reset:success": _vm.resetSuccess,
          "update:token": function ($event) {
            _vm.resetToken = $event
          },
          "update:username": function ($event) {
            _vm.username = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }